export default "__VITE_ASSET__B_BTuw7p__"